import { api, ApiError } from "../api";
import { estado } from "../estado";
import { esc, LOGO } from "../ui";
import type { Vista } from "./tipos";

export function login(alEntrar: () => void): Vista {
  const t = estado.tenant;
  return {
    full:
      '<div class="login">' +
        '<div class="lado">' +
          '<div class="orbe" style="width:420px;height:420px;background:var(--accentSoft);top:-120px;right:-100px"></div>' +
          '<div class="orbe" style="width:300px;height:300px;background:var(--info);bottom:-80px;left:-60px"></div>' +
          '<div style="display:flex;align-items:center;gap:10px;position:relative"><div class="logo" style="width:32px;height:32px;border-radius:9px">' + LOGO(16) + '</div><div style="font-size:17px;font-weight:650;letter-spacing:-.2px">' + esc(t?.nombreApp || "AIMAK") + '</div><div style="font-size:11px;opacity:.6;margin-left:6px">' + esc(t?.nombre || "") + " · beta</div></div>" +
          '<div class="frase" style="position:relative">Nadie ve nada hasta que alguien se lo abrió.</div>' +
          '<div class="nota" style="position:relative">Cada usuario entra con cero accesos, y ' + esc(t?.nombreChat || "Makai") + ' nunca ve más que su usuario. Lo que sí es tuyo desde el primer día: una memoria propia, que ' + esc(t?.nombreChat || "Makai") + ' construye contigo y lee en cada respuesta.</div>' +
        "</div>" +
        '<div class="form"><div class="caja">' +
          '<div class="eyebrow">Beta · ' + esc(t?.nombre || "tenant") + "</div>" +
          "<h1>Entrar a " + esc(t?.nombreApp || "AIMAK") + "</h1>" +
          '<div style="font-size:12.5px;color:var(--text3);line-height:1.5">Cada persona tiene sus propios accesos y su propia memoria. Entra con las credenciales que te dieron.</div>' +
          '<div class="lbl">CORREO</div><input id="lg-email" type="email" autocomplete="username" placeholder="tu@correo.com" value="' + esc(estado.pref.ultimoEmail) + '">' +
          '<div class="lbl">CONTRASEÑA</div><input id="lg-pass" type="password" autocomplete="current-password" placeholder="contraseña">' +
          '<button id="lg-entrar" class="btn primario" style="width:100%;justify-content:center;margin-top:18px;padding:11px">Entrar</button>' +
          '<div id="lg-error" class="aviso crit oculto" style="margin-top:12px"></div>' +
          '<div style="display:flex;justify-content:space-between;margin-top:18px;font-size:11.5px;color:var(--text4)"><span>Un container por agencia · sin base maestra de usuarios</span></div>' +
        "</div></div>" +
      "</div>",
    despues(root) {
      const email = root.querySelector<HTMLInputElement>("#lg-email")!;
      const pass = root.querySelector<HTMLInputElement>("#lg-pass")!;
      const err = root.querySelector<HTMLElement>("#lg-error")!;
      const btn = root.querySelector<HTMLButtonElement>("#lg-entrar")!;
      const entrar = async () => {
        err.classList.add("oculto");
        const e = email.value.trim().toLowerCase();
        if (!e || !pass.value) { err.textContent = "Escribe tu correo y tu contraseña."; err.classList.remove("oculto"); return; }
        btn.disabled = true;
        try {
          estado.me = await api.login(e, pass.value);
          estado.pref.ultimoEmail = e; estado.guardar();
          alEntrar();
        } catch (ex) {
          const a = ex as ApiError;
          err.textContent = a.codigo === "credenciales" ? "Correo o contraseña incorrectos." : a.mensaje;
          err.classList.remove("oculto");
        } finally { btn.disabled = false; }
      };
      btn.onclick = entrar;
      pass.onkeydown = (e) => { if (e.key === "Enter") entrar(); };
      email.onkeydown = (e) => { if (e.key === "Enter") entrar(); };
      if (!email.value) email.focus(); else pass.focus();
    },
  };
}
